import { FinOptsys } from './ProductConfig/FinOptSys/FinOptSys';

interface ClientConfig {
  [clientId: string]: {
    id: string;
    logo: any;
    login: {
      logo: any;
      fosLink: boolean;
      carouselDescription: boolean;
      fosLogoAtBottom: boolean;
      disableMfa: boolean;
    };
    landingPath?: string;
    adminToolAllow?: boolean;
    renameAllInRateToRepoRate?: boolean;
    landingPathFn?: any;
    navbar: {
      disableThemeSwitch: boolean;
      disableDefaultHomepage: boolean;
      disableHelpIcon: boolean;
      disableDocumentation: boolean;
      showCookieConsent: boolean;
    };
    // peerToPeer: {
    // 	orderTypeTitle: {[orderType: string]: {label: string; title: string}}
    // 	orderType: string[]
    // 	orderEntry: {
    // 		[field: string]: string | boolean | string[] | {[type: string]: string[]} | Record<string, string>[]
    // 		displayStepsCol: boolean
    // 		allowFloatingRate: boolean
    // 		allowAllInRate: boolean
    // 		uploadBasket: boolean
    // 		tradeHolidayCheck: boolean
    // 	}
    // 	orderDetail: {
    // 		hideIndeminifyFeeColumn: boolean
    // 		appendContractTypeToStrategy: boolean
    // 		settlementTab: boolean
    // 		collateralColumnDefsField: string[]
    // 		termAndCondition: boolean
    // 		allowCusipCandDValidation: boolean
    // 		editableDuration: boolean
    // 		disableTradeAndSettleDate: boolean
    // 	}
    // 	orderNegotiation: {
    // 		startCashEditable: boolean
    // 	}
    // }
    abcPortfolio: {
      defaultColumn: boolean;
      isFetchAllEntriesConfig: boolean;
    };
    collateralBasket: {
      fetchBasketItems: {
        optimizedCusipTemplate: boolean;
      };
      defaultStrategy: any;
      defaultTemplateType: string | null;
      basketCreationInputField: {
        template: boolean;
        schedule: boolean;
        currencies: string[];
        clientRiskTypeTitle: string;
      };
      collateralBasketConstruction: {
        [field: string]: string | boolean | string[] | { [type: string]: string[] };
      };
      collateralBasketNegotiation: {
        [field: string]: string | boolean | string[] | { [type: string]: string[] };
      };
      useEnrichedSecurityQuery: boolean;
      // restrictedColDefs: any[]
    };
    collateralOptimizationDashboard: {
      title: string;
      enableObjectiveWeights: boolean;
    };
    accountSettings: {
      groups: {
        showTradeType: boolean;
      };
      clients: {
        isLeDeposAllowed: boolean;
      };
    };
    repo: {
      tradeTicketButton: boolean;
    };
    tradeBlotter: {
      orderEntry: {
        [field: string]:
          | string
          | boolean
          | string[]
          | { [type: string]: string[] }
          | Record<string, string>[];
      };
      strategy: any[];
      fieldDecimal: number;
      allInPriceFieldDecimal: number;
    };
    dashboardSettings: {
      enableRollTrade: boolean;
      enableNewCollateralOptDashBoard: boolean;
      displayCOFticker: boolean;
      displaySODticker: boolean;
      startCashColumnExist: boolean;
      heatMapMessageDisplay: boolean;
    };
    portfolioUploadConfirm: {
      displayMessage: boolean;
      displayRestrictedMessage: boolean;
    };
  };
}

export const CLIENT_CONSTANTS = {
  FINOPTSYS: 'finOptSys',
};

export const Config = {
  clientConfigId: CLIENT_CONSTANTS.FINOPTSYS,
  set setActiveConfig(clientConfigId: string) {
    this.clientConfigId = clientConfigId;
  },
  get activeConfig() {
    return clientConfig[this.clientConfigId];
  },
};

export const clientConfig: ClientConfig = {
  [CLIENT_CONSTANTS.FINOPTSYS]: FinOptsys,
};
